import { createContext, PropsWithChildren, useCallback, useEffect, useState } from "react";
import { ItemService } from "../../services/Item";
import { Button, MenuProps } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { getCurrentUser, USER_ROLES } from "../../services/User";
import { PlusCircleOutlined, ToolOutlined } from '@ant-design/icons';
type MenuItem = Required<MenuProps>['items'][number];

type ItemsContextType = {
    items: MenuItem[],
    selectedItem: string[],
    getTitles: (selectFirst?: boolean) => Promise<void>,
    onClickTitle: (e: {key: string}) => void
}

function getItem(
    label: React.ReactNode,
    key: React.Key,
    children?: MenuItem[],
    icon?: React.ReactNode,
    type?: 'group',
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type,
    } as MenuItem;
}

type Title = {
    title: string;
    _id: string;
    children: { title: string, children: string }[]
}

export const ItemsContext = createContext<ItemsContextType>({items: [], selectedItem: [], getTitles: async () => {}, onClickTitle: ()=>{}});


export const ItemsProvider = ({children} : PropsWithChildren) => {

    const [items, setItems] = useState<MenuItem[]>([]);
    const [selectedItem, setSelecctedItem] = useState<string[]>([]);
    const [country, setCountry] =useState<string>('')
    const params = useParams();
    const navigate = useNavigate();
    const user = getCurrentUser();

    const onClickTitle = useCallback((e: { key: string }) => {
            setSelecctedItem([e.key])
            navigate(`${params.country}/${e.key}`, { replace: true })
    }, [navigate, params.country]);

    const getTitles = useCallback(async (selectFirst?: boolean) => {
        const country = params.country;
        if(country){
            const { data } = await ItemService.getTitles(country);
            
            const menuItems = data.map(({ title, _id, children }: Title) => {
                const childrenMap: MenuItem[] = children.map((c: { title: string; children: string; }) => { return getItem(c.title, c.children) })
                return getItem(
                    <Button className="menu-button" type="text" onClick={() => onClickTitle({key: _id})}>{title}</Button>,
                    _id,
                    childrenMap.length ? childrenMap : undefined
                )
            })
            if ((user.role === USER_ROLES.ADMIN_COUNTRY || user.role === USER_ROLES.ADMIN) && country===user.country ) {
                menuItems.push(getItem('Add new Item', 'add', undefined, <PlusCircleOutlined />))
                menuItems.push(getItem('Admin', 'admin', [
                    getItem('Tools', 'tools', undefined),
                    getItem('Menu Order', 'menuorder', undefined)
                ], <ToolOutlined /> ))
            }
            setItems(menuItems)
            
            if (selectFirst===true && menuItems[0]){
                onClickTitle({key: menuItems[0].key})
            }
        }
    }, [params.country, user.role, user.country, onClickTitle])
   
    useEffect(()=>{
        if(params.country && params.country != country){ 
            setCountry(params.country);
            getTitles(true);
        }
    }, [params.country, getTitles])

    return ( 
        <ItemsContext.Provider value={{
            items,
            selectedItem,
            getTitles,
            onClickTitle
        }}>
            {children}
        </ItemsContext.Provider>
    )
}



